var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgI = function SvgI(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm-3.8 8a.2.2 0 0 0-.2.2v1.1c0 .11.09.2.2.2h4.6a.2.2 0 0 0 .2-.2V9.7a.2.2 0 0 0-.2-.2H3.5V4.2a.2.2 0 0 0-.2-.2H.2a.2.2 0 0 0-.2.2v1.1c0 .11.09.2.2.2h1.3v4H.2Z",
    fill: "#fff"
  })));
};

export default SvgI;